import BidTab from "../BOMTab/BidTab";
import ECSList from "./List";
import RequisitionTab from "./RequisitionTab";

export const ECSTabs = [
  {
    label: "Equipment List",
    panel: <ECSList />,
  },
  {
    label: "MRQ",
    panel: <RequisitionTab name="MRQ" />,
  },
  {
    label: "BID EVALUATION",
    panel: <BidTab isEcs={true} />,
    // panel: <>hello</>,
  },
  {
    label: "PO",
    panel: <RequisitionTab name="PO" />,
  },
];
